module.exports = __webpack_public_path__ + "img/ru_Ecran 5.baeb06e8.png";